<h2 mat-dialog-title>Prompt</h2>
<mat-dialog-content>
  {{message}}
</mat-dialog-content>
<mat-dialog-actions align="end">
  <button mat-button (click)="onCancel()">No</button>
  <button mat-button color="primary" (click)="onConfirm()">Yes</button>
</mat-dialog-actions>
